// Text for the Data tab's history sections. Kept with the component (component-local vue-i18n
// messages); anything not found here falls back to the shared gw-js-lib locales.
export default {
  en: {
    sd: {
      battery: 'Battery',
      measured: 'Measured',
      range: { 7: '7 days', 30: '30 days', 90: '90 days' },
      change24: '{v} vs 24 h ago',
      noHistory: 'No readings in this period.',
      loading: 'Loading…',
      daily: 'Daily readings',
      dailyNote: 'Daily averages for the last 30 days. Click a day to see it hour by hour.',
    },
  },
  es: {
    sd: {
      battery: 'Batería',
      measured: 'Medido',
      range: { 7: '7 días', 30: '30 días', 90: '90 días' },
      change24: '{v} vs hace 24 h',
      noHistory: 'No hay lecturas en este periodo.',
      loading: 'Cargando…',
      daily: 'Lecturas diarias',
      dailyNote: 'Promedios diarios de los últimos 30 días. Haga clic en un día para verlo hora por hora.',
    },
  },
};
